module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("同龄分群")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄档"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择年龄档"
    },
    model: {
      value: (_vm.queryParam.ageBand),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageBand", $$v)
      },
      expression: "queryParam.ageBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档（3-5）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档（6-8）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档（9+）")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "8px 0",
      "color": "#888"
    }
  }, [_vm._v("样本 n<1000 时学生端不展示全国/同城对照。本页只读，月度校准属 P3。")]), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/cohorts/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b91d9092","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexScoreCohortList.vue
// module id = 1937
// module chunks = 8